import React, { useEffect, useState } from "react";
import API from "../../Network/API";
import ContentLoader from "react-content-loader"
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import EditMeeting from "../Modal/EditMeeting";
import RecordingPlayerModal from "../Modal/RecordingPlayerModal";
import { useTranslation } from "react-i18next";

export default function MeetingHistory() {
  const {t} = useTranslation()
  const [meetingList, setMeetingList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [demo_data, setDatas] = useState([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }]);
  const [progress, setProgress] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [next_page, setNextPage] = useState('/my_meeting_history');
  const [nextPageUrl, setNextPageURL] = useState(null);
  const [lengthData, setDataLength] = useState(0);
  const [sc_meet, setScMeet] = useState(null);
  const [edit_modalDialog, setEditModalDialog] = useState(false);
  const [modalDialog, setModalDialog] = useState(false);

  // Recording player modal state
  const [recordingModal, setRecordingModal] = useState(false);
  const [selectedRecording, setSelectedRecording] = useState(null); // { livekitRoom, title, sizeDisplay, endedAt }

  const openRecordingModal = (meeting) => {
    setSelectedRecording({
      livekitRoom:  meeting.livekit_room_name || null,
      roomName:     meeting.room_name,          // fallback for rooms without livekit_room_name
      title:        meeting.room_title,
      sizeDisplay:  meeting.recording_size_bytes
                      ? formatBytes(meeting.recording_size_bytes)
                      : null,
      endedAt:      meeting.recording_ended_at,
    });
    setRecordingModal(true);
  };

  // Mirrors backend formatBytes — kept in sync so sizes display before the modal opens.
  const formatBytes = (bytes) => {
    if (bytes >= 1_073_741_824) return `${(bytes / 1_073_741_824).toFixed(1)} GB`;
    if (bytes >= 1_048_576)     return `${(bytes / 1_048_576).toFixed(1)} MB`;
    return `${(bytes / 1_024).toFixed(1)} KB`;
  };

  const myArr = JSON.parse(localStorage.getItem('user_data'));
  useEffect(() => {
    fetchRepositories()
  }, []);

  function fetchRepositories() {

    setProgress(true)

    API.get(next_page, {
      'offset': meetingList.length
    }).then((response) => {

      const paginator = response.data.data;
      setDataLength(paginator.total)
      if (paginator.meeting_data.length) {
        setMeetingList(paginator.meeting_data)
        setProgress(false)
        setNextPageURL(paginator.next_page_url)
        setPage((page + 1))
      }

    }).catch((error) => {
      setProgress(true)

    });

  }

  const toggleEditMeeting = (meeting_room) => {
    setScMeet(meeting_room)
    setEditModalDialog(!modalDialog)
  };

  function fetchRepositoriesNext() {

    setLoading(true)

    API.get(next_page + '?page=' + page, {
      'offset': meetingList.length
    }).then((response) => {
      setLoading(false)
      const paginator = response.data.data;
      setDataLength(paginator.total)
      if (paginator.meeting_data.length) {
        setMeetingList([...meetingList, ...paginator.meeting_data])
        setNextPageURL(paginator.next_page_url)
        setPage((page + 1))
        setIsFetching(false)
      }
    }).catch((error) => {
      setLoading(false)
    });

  }

  // const meeting_delete = (m_id) => {
  //   var result = window.confirm("Are you sure want to delete?");
  //   if (result == true) {
  //     setLoading(true)
  //     API.delete("/meeting_delete/" + m_id).then((response) => {
  //       setLoading(false)
  //       if (response.data.success === true) {
  //         toast.success('delete successfully');
  //       }
  //     });
  //   }
    
  // }



  return (
    <>
      <div className="min-vh-100 bg-white">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-7">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h2 className="mh-heading mb-0">{t('Meeting History')}</h2>
                <Link to="/meeting" className="sv-pill">
                  <i className="fa-solid fa-arrow-left"></i>
                  Back to Meetings
                </Link>
              </div>

              {progress && demo_data?.map((post, i) => (
                <div key={i} className="mb-2">
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={80}
                    viewBox="0 0 100 80"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    className="rounded-2"
                  >
                    <rect x="8" y="15" rx="6" ry="6" width="10" height="10" />
                    <rect x="22" y="12" rx="3" ry="3" width="30" height="5" />
                    <rect x="22" y="20" rx="2" ry="2" width="40" height="3" />
                    <rect x="8" y="35" rx="3" ry="3" width="20" height="3" />
                    <circle cx="12" cy="50" r="3" />
                    <circle cx="20" cy="50" r="3" />
                    <circle cx="28" cy="50" r="3" />
                    <rect x="75" y="35" rx="3" ry="3" width="12" height="6" />
                  </ContentLoader>
                </div>
              ))}

              {!progress && meetingList?.map((meeting, index) => (
                <div key={index} className="mh-card">
                  <div className="mh-date">
                    <div className="mh-date-day">{new Date(meeting.created_at).getDate()}</div>
                    <div className="mh-date-month">{new Date(meeting.created_at).toLocaleDateString('en-US', { month: 'short' })}</div>
                    <div className="mh-date-year">{new Date(meeting.created_at).getFullYear()}</div>
                  </div>

                  <div className="mh-body">
                    <div className="mh-title-row">
                      <h6 className="mh-title">{meeting.room_title}</h6>

                      {/* ── Live recording indicator ── */}
                      {meeting.is_recording && (
                        <span className="mh-badge mh-badge-rec-live" title="Recording in progress">● REC</span>
                      )}

                      {/* ── Completed meeting badge ── */}
                      {!meeting.is_recording && (
                        <span className="mh-badge mh-badge-done" title="Completed meeting">
                          <i className="fa-solid fa-check"></i> Completed
                        </span>
                      )}

                      {/* ── REC available badge ── */}
                      {meeting.is_recorded && !meeting.is_recording && (
                        <span className="mh-badge mh-badge-rec" title="Recording available">
                          <i className="fa-solid fa-circle-play"></i> REC
                        </span>
                      )}
                    </div>

                    <div className="mh-bottom-row">
                      <div className="mh-avatars">
                        {meeting.room_history.slice(0, 3).map((user, userIndex) => (
                          <Link key={userIndex} to={`/contact/${user.id}`}>
                            <div className="mh-avatar" style={{ backgroundImage: `url(${user.avatar})` }} />
                          </Link>
                        ))}
                        {meeting.room_history.length > 3 && (
                          <Link to={`/meeting-details/${meeting.room_name}`}>
                            <div className="mh-avatar mh-avatar-more">+{meeting.room_history.length - 3}</div>
                          </Link>
                        )}
                      </div>

                      <div className="mh-actions">
                        <a
                          href={`/meeting/${meeting.room_name}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mh-icon-btn"
                          title="Start again"
                        >
                          <i className="fa-solid fa-play"></i>
                        </a>
                        <button
                          onClick={() => toggleEditMeeting(meeting)}
                          className="mh-icon-btn"
                          title="Edit meeting"
                        >
                          <i className="fa-solid fa-edit"></i>
                        </button>

                        {/* ── Watch Recording button ── */}
                        {meeting.is_recorded && !meeting.is_recording && (
                          <button
                            id={`watch-recording-${meeting.room_name}`}
                            onClick={() => openRecordingModal(meeting)}
                            className="mh-icon-btn mh-icon-btn-rec"
                            title="Watch recording"
                          >
                            <i className="fa-solid fa-circle-play"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <Link to={`/meeting-details/${meeting.room_name}`} className="sv-pill mh-details">
                    {t('Details')}
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              ))}

              {nextPageUrl != null && (
                <div className="text-center vp-load-more">
                  <button
                    className="vp-load-more-btn"
                    onClick={fetchRepositoriesNext}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    Load more
                  </button>
                </div>
              )}

              {meetingList.length === 0 && !progress && (
                <div className="mh-empty text-center">
                  <div className="mh-empty-icon">
                    <i className="fa-solid fa-clock-rotate-left"></i>
                  </div>
                  <h5 className="mh-empty-title">No meeting history</h5>
                  <p className="mh-empty-text">Your completed meetings will appear here</p>
                  <Link to="/meeting" className="sv-pill sv-pill-dark">
                    <i className="fa-solid fa-calendar-plus"></i>
                    Schedule Meeting
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EditMeeting isModalVisible={edit_modalDialog} meetingRoom={sc_meet} handleShowB={() => setEditModalDialog(false)}/>

      {/* ── Recording Player Modal ── */}
      <RecordingPlayerModal
        isOpen={recordingModal}
        onClose={() => setRecordingModal(false)}
        livekitRoom={selectedRecording?.livekitRoom}
        roomName={selectedRecording?.roomName}
        meetingTitle={selectedRecording?.title}
        sizeDisplay={selectedRecording?.sizeDisplay}
        endedAt={selectedRecording?.endedAt}
      />

      {/* ── REC pulse animation ── */}
      <style>{`
        @keyframes recPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </>
  )
}